module.exports = __webpack_public_path__ + "static/media/icosahedron.0ef23cf9.obj";